import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// routes
import { PATH_AUTH } from '../../../routes/paths';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
// components
import Iconify from '../../../components/iconify';
import { useSnackbar } from '../../../components/snackbar';

// ----------------------------------------------------------------------

NavSidebarLogout.propTypes = {
  isMini: PropTypes.bool,
  onClose: PropTypes.func,
};

export default function NavSidebarLogout({ isMini = false, onClose }) {
  const navigate = useNavigate();
  const { logout } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();

  const handleLogout = async () => {
    try {
      await logout();
      onClose?.();
      navigate(PATH_AUTH.login, { replace: true });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };

  return (
    <Box sx={{ flexShrink: 0, px: isMini ? 1 : 2, pb: isMini ? 2 : 2.5, pt: isMini ? 1 : 0 }}>
      <Box
        component="button"
        type="button"
        onClick={handleLogout}
        aria-label="Logout"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 1,
          py: isMini ? 1.25 : 1.5,
          border: 'none',
          borderRadius: 1.5,
          cursor: 'pointer',
          fontSize: 14,
          fontWeight: 700,
          fontFamily: 'inherit',
          bgcolor: '#FCF9F5',
          color: 'primary.main',
          transition: 'background-color 0.2s, transform 0.15s',
          '&:hover': { bgcolor: '#f6f0e6' },
          '&:active': { transform: 'scale(0.99)' },
        }}
      >
        <Iconify icon="eva:log-out-fill" width={isMini ? 22 : 18} />
        {!isMini && <Box component="span" sx={{ ml: 1 }}>Logout</Box>}
      </Box>
    </Box>
  );
}
